module.exports = __webpack_public_path__ + "gfx/DC-23-R3-02.png";